import { usePresentationContext } from '../../legacy-context/presentationContext';
import { ChoicesPresentation } from './ChoicesPresentation';
import { useChoicesPresentation } from './hooks/use-choices-presentation';
import { TrendsDataHandler } from './TrendsDataHandler';

export const ChoicesPresentationDataHandler = () => {
  const presentationProps = useChoicesPresentation();
  const { useTrends } = usePresentationContext();
  const { showTrends } = useTrends();
  return (
    <ChoicesPresentation {...presentationProps}>
      {showTrends && (
        <TrendsDataHandler
          choices={presentationProps.choices}
          shouldHideResults={presentationProps.shouldHideResults}
        />
      )}
    </ChoicesPresentation>
  );
};
